import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDate } from "src/shared/hooks/useDate"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import InputDateModal from "src/shared/components/forms/input-date/sections/InputDateModal/InputDateModal"
import Selector from "src/shared/components/forms/Selector/Selector"

type Param = {
    fecha_final: string
    fecha_inicial: string
}

type HistorialSelectorProps = {
    onDateChange: (param: Param) => void
}

const options = [
    { label: "Propinas acumuladas", value: "acumuladas" },
    { label: "Propinas pagadas", value: "pagadas" },
]

const HistorialSelector = ({ onDateChange }: HistorialSelectorProps) => {
    const { areSameDay } = useDate()
    const { nowHotel, getStartOfHotelDayISO, getEndOfHotelDayISO } = useFormatDate()
    const [selectorValue, setselectorValue] = useState("")
    const [value, setValue] = useState<Date[]>([])

    const navigate = useNavigate()

    const onFieldChange = (date: Date[]) => {
        if (date.length === 2) {
            onDateChange({
                fecha_inicial: getStartOfHotelDayISO(date[0]),
                fecha_final: getEndOfHotelDayISO(date[1]),
            })
        } else if (date.length === 1) {
            onDateChange({
                fecha_inicial: getStartOfHotelDayISO(date[0]),
                fecha_final: getEndOfHotelDayISO(date[0]),
            })
        } else {
            onDateChange({ fecha_inicial: "", fecha_final: "" })
        }
    }

    return (
        <>
            <InputDateModal
                modalClosableOnClickOutside={false}
                isOpen={selectorValue === options?.[0]?.value}
                disabledAfterOrEqualDate={nowHotel}
                selectableOnDblClick={false}
                onClose={() => setselectorValue("")}
                onReset={() => {
                    setValue([])
                    onFieldChange([])
                }}
                onConfirm={() => {
                    if (value.length === 0) {
                        return
                    }
                    setselectorValue("")
                    onFieldChange(value)
                }}
                isRange={true}
                onChange={(date) => {
                    if (value.length === 0 || date <= value[0]) {
                        setValue([date])
                        return
                    }
                    if (value?.length === 2 && areSameDay(nowHotel, date)) {
                        setValue([date])
                        return
                    }
                    if (value?.length === 2) {
                        setValue([])
                        return
                    }
                    setValue([value[0], date])
                }}
                value={value}
            />
            <Selector<string>
                title={"Historial"}
                value={selectorValue}
                icon="calendarFill"
                onChange={(v) => {
                    if (options?.[1]?.value === v) navigate("/u/propinas/historial-pagos")
                    setselectorValue(v)
                }}
                options={options}
            />
        </>
    )
}

export default HistorialSelector
